import { render, staticRenderFns } from "./LessonEdit.vue?vue&type=template&id=ddd98d46&scoped=true&"
import script from "./LessonEdit.vue?vue&type=script&lang=js&"
export * from "./LessonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd98d46",
  null
  
)

export default component.exports